import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

// let Swiper = require('swiper/swiper-bundle.js');
// window.Swiper = Swiper;

import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.min.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';
import Thumbs from 'swiper/modules/thumbs.min.mjs';

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Autoplay = Autoplay;
window.Thumbs = Thumbs;

// import ResizeSensor from 'resize-sensor';
// window.ResizeSensor = ResizeSensor;

// import StickySidebar from 'sticky-sidebar-v2';
// window.StickySidebar = StickySidebar;

import hcSticky from 'hc-sticky';
window.hcSticky = hcSticky;

require("priority-plus");

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

// import dragScroll from "dragscroll/dragscroll";
// window.dragScroll = dragScroll;
